export default class NewsletterDataProvider {
  constructor(Newsletter) {
    "ngInject"
    this.NewsletterService = Newsletter;
  }

  editor() {
    // Initialize
    tinymce.EditorManager.editors = [];
    tinymce.init({
      selector: '.tinymce',
      plugins: ['paste', 'link', 'autoresize']
    });
    tinymce.init({
      selector: '.full-tinymce',
      toolbar1: 'undo redo | insert | styleselect | bold italic | alignleft aligncenter alignright alignjustify | bullist numlist outdent indent | link image',
      toolbar2: 'print preview media | forecolor backcolor emoticons ',
      image_advtab: true,
      plugins: [
        'advlist autolink lists link image charmap print preview hr anchor pagebreak',
        'searchreplace visualblocks visualchars code fullscreen',
        'insertdatetime media nonbreaking save table contextmenu directionality',
        'paste textcolor colorpicker textpattern imagetools toc'
      ]
    })
  }

  getSubscribers(data) {
    return this.NewsletterService.loadSubscribers(data)
      .then((result) => {
        return result;
      })
  }

  removeSubscriber(id) {
    return this.NewsletterService
      .removeSubscriber(id)
      .then((resp) => {
        return resp;
      })
  }

  getNewsletter(type) {
    return this.NewsletterService
      .getNewsletter(type)
      .then((resp) => {
        return resp;
      })
  }


}


// WEBPACK FOOTER //




/** WEBPACK FOOTER **
 ** C:/Users/larss/Documents/signlabs-admin-frontend/client/app/modules/newsletter/services/newsletter.dataprovider.service.js
 **/